<template>
  <div class="bg-[#F4F1ED] px-4 font-Spectral">
    <!-- カレンダー注釈: 凡例テキストと同じ中央寄せコンテナに揃える -->
    <div v-if="!!$slots.note" class="flex justify-center pt-1">
      <div class="w-full max-w-[350px] pb-2 pl-1 font-bold md:max-w-[650px] md:pl-2">
        <slot name="note" />
      </div>
    </div>
    <!-- 上段: CONFIRMED_INSTANTLY と ON_REQUEST -->
    <div class="m-auto flex justify-around pb-2">
      <div v-for="status in topRowStatuses" :key="status" class="flex items-center">
        <span
          :class="[
            'inline-flex flex-shrink-0 items-center justify-center border-[0.5px] border-gold3 bg-white font-bold text-black2',
            status === 'CONFIRMED_INSTANTLY' ? 'h-6 w-6 rounded-full' /* 24px, radius 26px(円) */ : 'h-5 w-5 rounded-[2px]' /* 20px, radius 2px */,
          ]"
        >
          <span class="flex h-[8px] w-[11px] items-center justify-center text-[10px] leading-none">17</span>
        </span>
        <p class="text-md ml-1 text-center text-black2 md:ml-2">{{ availabilityStatusMap[status].label }}</p>
      </div>
    </div>
    <!-- 下段: FULL, UNAVAILABLE -->
    <div class="m-auto flex justify-around pb-4">
      <div v-for="status in bottomRowStatuses" :key="status" class="flex items-center">
        <div class="relative">
          <img alt="" class="m-0 h-6 w-6 p-0" :src="availabilityStatusMap[status].imagePath" />
          <p :class="[props.datePositioningClass ? props.datePositioningClass : 'top-[0.28rem] md:top-[0.26rem]', 'absolute left-1/2 -translate-x-1/2']">
            <span class="text-sm text-black1 opacity-30">17</span>
            <span v-if="status === 'FULL'" class="absolute left-0 right-0 top-1/2 h-[1px] w-full -translate-y-1/2 border-t border-black1 opacity-30"> </span>
          </p>
        </div>
        <p class="text-md ml-1 pt-1 text-center text-black2 md:ml-2">{{ availabilityStatusMap[status].label }}</p>
      </div>
    </div>
    <!-- 凡例テキスト（SP: 350×66 中央寄せ / PC: 幅広めで中央寄せ） -->
    <div class="flex justify-center">
      <ul class="min-h-[66px] w-full max-w-[350px] list-disc pb-2 pl-5 text-sm text-black2 md:min-h-0 md:max-w-[650px]">
        <li>
          <span class="font-bold">{{ availabilityStatusMap.CONFIRMED_INSTANTLY.label }}:</span>
          {{ availabilityStatusMap.CONFIRMED_INSTANTLY.description }}
        </li>
        <li>
          <span class="font-bold">{{ availabilityStatusMap.ON_REQUEST.label }}:</span>
          {{ availabilityStatusMap.ON_REQUEST.description }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { availabilityStatusMap, type AvailabilityStatus } from '@/models/wabunka/view/experience/wabunkaExperienceCalendar';

interface Props {
  datePositioningClass?: string;
}

const props = defineProps<Props>();

const topRowStatuses: AvailabilityStatus[] = ['CONFIRMED_INSTANTLY', 'ON_REQUEST'];
const bottomRowStatuses: AvailabilityStatus[] = ['FULL', 'UNAVAILABLE'];
</script>
